import React from 'react';
import { FlaggedVenueIndicatorProps } from 'ui-components/venue-status-indicator/venue-status-indicator';
import { useCheckVenueStatus } from 'features/mobile-report/components/explore-mobile/hooks/use-check-venue-status';
import { useIsRestrictedPoi } from 'hooks/use-restricted-poi/use-restricted-poi';
import {
    getReportEntityClosingDate,
    getReportEntityFlag,
} from 'core/services/report-entities-service/report-entities-service';
import { useCheckPoiForPropertyReport } from 'features/explore/hooks/use-check-for-property-report';
import { TooltipIcon } from '@placer-ui/components';

type VenueStatusIndicatorV3Props = Pick<FlaggedVenueIndicatorProps, 'poi' | 'custom'>;

export const VenueStatusIndicatorV3 = ({ poi, custom }: VenueStatusIndicatorV3Props) => {
    const checkVenueStatus = useCheckVenueStatus();
    const isRestrictedPoiCallback = useIsRestrictedPoi();
    const checkPoiForPropertyReport = useCheckPoiForPropertyReport();

    if (!poi) return null;

    const { text, disabled } = checkPoiForPropertyReport(poi);
    const status = checkVenueStatus(poi);

    const isRestricted = isRestrictedPoiCallback(poi);
    const flag = getReportEntityFlag(poi);
    const closingDate = getReportEntityClosingDate(poi);

    if (!flag && !closingDate && !isRestricted && !disabled && !custom) {
        return null;
    }

    let tooltipText = text || custom;
    if (status) tooltipText = `${status} - ${text}`;

    return (
        <TooltipIcon
            title={tooltipText}
            testId="venue-status-indicator"
            iconProps={{
                type: 'Warning',
            }}
            tooltipProps={{
                appendToParent: true,
                placement: 'top',
                maxWidth: 250,
                testId: 'venue-status-indicator',
            }}
        />
    );
};
